import { Router } from '@angular/router';
import { Injector, NgZone } from '@angular/core';

// Configs
import {
  DEFAULT_PROCESS_ID_CONSTANT,
  DISPERSION_METHOD_COMPONENTS_CONSTANT,
  DISPERSION_METHOD_STATE_ENUMERATION,
} from '../configs';

// Models
import { DispersionMethodStrategyType } from '../models';
import { ProductType } from '@core/model/enums';

// Shared
import { MarketingEventEnumeration, MarketingEventService } from '@shared/services';
import { ROUTES_CONSTANTS } from '@shared/configs';

export const RETRP_DISPERSION_METHOD_STRATEGY = ({
  injector,
}: {
  injector: Injector;
}): DispersionMethodStrategyType => {
  const ngZone: NgZone = injector.get(NgZone);
  const router: Router = injector.get(Router);
  const marketingEventService: MarketingEventService = injector.get(MarketingEventService);

  return {
    viewName: DISPERSION_METHOD_COMPONENTS_CONSTANT.VERIFICATION_SELECT_ACCOUNT,
    productId: ProductType.RETRP,
    processId: DEFAULT_PROCESS_ID_CONSTANT,
    finalProcessFunc: ({ state }) => {
      ngZone.run(() => {
        if (state === DISPERSION_METHOD_STATE_ENUMERATION.APPROVED) {
          marketingEventService.sendMarketingEvents(MarketingEventEnumeration.LOAN_APPLICATION_SIGNATURE_RFYA);
          router.navigate([ROUTES_CONSTANTS.REFERENCES]);
        } else {
          router.navigate([ROUTES_CONSTANTS.HOME]);
        }
      });
    },
  };
};
